export default function getCropBasedPGLink() {
  const source = localStorage.getItem("source");
  const farmerId = localStorage.getItem("farmerId");

  if (CROP_BASED_PG_REPORT_URL[source]) {
    return CROP_BASED_PG_REPORT_URL[source].replace("{{farmerid}}", farmerId);
  }
  return null;
}

const CROP_BASED_PG_REPORT_URL = {
  B2BMH:
    "https://lookerstudio.google.com/embed/reporting/f0037b7b-bb9f-4984-81a7-f0dc4d964253/page/uE1GE?params=%7B%22fid%22%3A%22{{farmerid}}%22%7D",
  B2BRJ:
    "https://lookerstudio.google.com/embed/reporting/c9093774-5cb5-4aba-becd-5a585e25171a/page/uE1GE?params=%7B%22fid%22%3A%22{{farmerid}}%22%7D",
  B2BUP:
    "https://lookerstudio.google.com/embed/reporting/bb77ff7c-9d6f-4e14-aa02-514df62e8227/page/uE1GE?params=%7B%22fid%22%3A%22{{farmerid}}%22%7D",
  B2BMP:
    "https://lookerstudio.google.com/embed/reporting/d1b39a17-c0f8-4749-b5be-1bc167808b97/page/uE1GE?params=%7B%22fid%22%3A%22{{farmerid}}%22%7D",
  B2BGJ:
    "https://lookerstudio.google.com/embed/reporting/b4c3cf90-ded2-4296-800e-09e912869222/page/uE1GE?params=%7B%22fid%22%3A%22{{farmerid}}%22%7D",
  B2BBH:
    "https://lookerstudio.google.com/embed/reporting/dfd28d3f-be9b-444c-a2e4-58bef1837026/page/uE1GE?params=%7B%22fid%22%3A%22{{farmerid}}%22%7D",
};
